// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"6ffe5ff1","605":"eea6b0cd","809":"62452d41","981":"af367b50"}[chunkId] + ".chunk.js";
};